import React, { useState, useCallback, memo } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { TbCopy } from "react-icons/tb";
import { TbCopyCheck } from "react-icons/tb";
import { useThemeColor } from "../hooks/useThemeColor";

const Section1 = memo(({ index, width, section1Ref }) => {
  const [isCopied, setIsCopied] = useState(false);
  const themeColor = useThemeColor(index);

  const handleCopy = useCallback(async () => {
    setIsCopied(true);
    try {
      await navigator.clipboard.writeText("npx orrin");
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = "npx orrin";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }, []);

  return (
    <div
      ref={section1Ref}
      className=" h-screen w-full flex items-center justify-center flex-col gap-5 select-none"
    >
      <div className="w-full h-[900px] absolute overflow-hidden flex z-[1] top-[-20%]">
        <div className="infiniteScrollHz">
          <h1 className="text-[50rem] whitespace-nowrap text-[#10110F] lilita opacity-[.2]">
            subhajit
          </h1>
        </div>
        <div className="infiniteScrollHz">
          <h1 className="text-[50rem] whitespace-nowrap text-[#10110F] lilita opacity-[.2]">
            subhajit
          </h1>
        </div>
      </div>
      <div className="flex items-center justify-center flex-col gap-5 z-[2]">
        {width > 768 ? (
          <div className="flex items-center justify-center flex-col gap-5">
            <h2 className="text-[100px] text-white leading-[5.5rem] text-center monospace">
              Hi,I'm Orrin,a <br />
              <span style={{ color: themeColor }}>Full Stack</span>{" "}
              Developer
            </h2>
            <div className="flex gap-4 text-center justify-center mb-4">
              <div className="flex items-center justify-center px-3 py-1.5 rounded-full bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">WEB</span>
              </div>
              <div className="flex items-center justify-center px-3 py-1.5 rounded-full bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-lg hover:shadow-green-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">Mobile</span>
              </div>
              <div className="flex items-center justify-center px-3 py-1.5 rounded-full bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">AI Integration</span>
              </div>
            </div>
            <p className="text-gray-400 max-w-[50%] text-center opacity-[.6]">
              I'm a skilled Software Developer specializing in <span className="text-white font-medium">web development</span>,
              <span className="text-white font-medium"> mobile applications</span>, and <span className="text-white font-medium">AI integration</span>.
              I create scalable solutions with SEO optimization and robust security using modern technologies
              like Next.js, React Native, Node.js, AWS, and PostgreSQL to help businesses grow and succeed.
            </p>
            <div
              onClick={handleCopy}
              className="monospace text-[17px] items-center opacity-[1] text-[white] rounded-[7px] px-[10px] py-[2px] flex gap-[10px] border border-[#404140] cursor-pointer"
            >
              <span style={{ color: themeColor }}>npx</span> orrin{" "}
              <span>{isCopied ? <TbCopyCheck /> : <TbCopy />}</span>
            </div>
          </div>
        ) : (
          <div
            onClick={handleCopy}
            className="flex items-center justify-center flex-col gap-5"
          >
            <h2 className="text-[10vw] text-white leading-[100%] text-center monospace">
              Hi,I'm Subhajit,a <br />
              <span style={{ color: themeColor }}>Full Stack</span>{" "}
              Developer
            </h2>
            <div className="flex gap-2 text-center justify-center mb-3 flex-wrap">
              <div className="flex items-center justify-center px-2 py-1 rounded-full bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-md hover:shadow-blue-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">WEB</span>
              </div>
              <div className="flex items-center justify-center px-2 py-1 rounded-full bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-md hover:shadow-green-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">Mobile</span>
              </div>
              <div className="flex items-center justify-center px-2 py-1 rounded-full bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 backdrop-blur-sm hover:scale-105 hover:shadow-md hover:shadow-purple-500/25 transition-all duration-300 cursor-default">
                <span className="text-white text-xs font-medium">AI Integration</span>
              </div>
            </div>
            <p className="text-gray-400 opacity-[.6] text-center w-[80%]">
              I'm a Software Developer specializing in <span className="text-white font-medium">web development</span>,
              <span className="text-white font-medium"> mobile applications</span>, and <span className="text-white font-medium">AI integration</span>.
              I create scalable solutions using Next.js, React Native, Node.js, AWS, and PostgreSQL.
            </p>
            <div className="monospace text-[17px] items-center opacity-[1] text-[white] rounded-[7px] px-[10px] py-[2px] flex gap-[10px] border border-[#404140] cursor-pointer">
              <span style={{ color: themeColor }}>npx</span> orrin{" "}
              <span>{isCopied ? <TbCopyCheck /> : <TbCopy />}</span>
            </div>
          </div>
        )}
        <div
          className={`absolute h-[150px] text-white opacity-[.5] ${width > 768 ? "bottom-8" : "bottom-4"}`}
        >
          <div className="mt-[-1px] arrow arrow1">
            <IoIosArrowDown className="text-[20px]" />
          </div>
          <div className="mt-[-1px] arrow arrow2">
            <IoIosArrowDown className="text-[20px]" />
          </div>
          <div className="mt-[-1px] arrow arrow3">
            <IoIosArrowDown className="text-[20px]" />
          </div>
        </div>
      </div>
    </div>
  );
});

Section1.displayName = 'Section1';

export default Section1;
